var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiltersStroke1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M22.508 9c.276 0 .492.224.492.5v1c0 .276-.216.5-.492.5h-6.684a2.99 2.99 0 0 1-2.816 2 2.99 2.99 0 0 1-2.816-2H7.508A.507.507 0 0 1 7 10.5v-1c0-.276.232-.5.508-.5h2.684a2.99 2.99 0 0 1 2.816-2 2.99 2.99 0 0 1 2.816 2zm0 10c.276 0 .492.224.492.5v1c0 .276-.216.5-.492.5h-2.684a2.99 2.99 0 0 1-2.816 2 2.99 2.99 0 0 1-2.816-2H7.508A.507.507 0 0 1 7 20.5v-1c0-.276.232-.5.508-.5h6.684a2.99 2.99 0 0 1 2.816-2 2.99 2.99 0 0 1 2.816 2z"
})));
export default SvgFiltersStroke1;